import PageShell, { PageHeader, Prose } from "@/components/PageShell";
import Seo from "@/components/Seo";

const AboutPage = () => (
  <PageShell>
    <Seo
      title="About — Nema TV"
      description="Nema TV is live TV from India, Bangladesh, Nepal and Pakistan — built for the diaspora. Learn who we are and why we're here."
      path="/about"
      schemas={[{
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: (process.env.REACT_APP_SITE_URL || "https://nematv.com") + "/" },
          { "@type": "ListItem", position: 2, name: "About", item: (process.env.REACT_APP_SITE_URL || "https://nematv.com") + "/about" },
        ],
      }]}
    />
    <PageHeader
      eyebrow="About Nema TV"
      title="Home, on every screen."
      subtitle="Nema TV is a live TV streaming service for the diaspora — the Desi TV Package (India, Bangladesh, Nepal and Pakistan) is live today, with a dedicated Arabic TV Package on the way."
    />
    <Prose>
      <h2>Why Nema TV exists</h2>
      <p>
        Home isn&apos;t a place — it&apos;s a signal, a sound, a face on the evening news that
        speaks your language. Nema TV was built because staying connected to that signal
        should feel effortless, wherever your day takes you.
      </p>

      <h2>What we do</h2>
      <p>
        We license and deliver live TV feeds from India, Bangladesh, Nepal and Pakistan
        and stream them at cinematic quality to your Roku, Fire TV, Android TV, iOS
        device, Android phone, and any modern web browser. One account. Every screen.
      </p>

      <h2>What&apos;s next</h2>
      <p>
        A dedicated <strong>Arabic TV Package</strong> is next on the roadmap.
        Coming soon — details announced closer to launch.
      </p>

      <h2>Get in touch</h2>
      <p>
        Product feedback, partnership ideas or press enquiries: reach us at{" "}
        <a href="mailto:contact@nematv.com">contact@nematv.com</a>.
      </p>
    </Prose>
  </PageShell>
);

export default AboutPage;
